import { render, staticRenderFns } from "./PeekCarousel.vue?vue&type=template&id=733e8192&"
import script from "./PeekCarousel.vue?vue&type=script&lang=js&"
export * from "./PeekCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PeekCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default})
